import { useEffect, useState } from "react";

/** Se suscribe a una media query y devuelve si cumple (se actualiza al rotar o redimensionar). */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    if (!window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** Por debajo del breakpoint `md` de Tailwind (768px). */
export function useIsMobile() {
  return useMediaQuery("(max-width: 767px)");
}

/** Dispositivo táctil sin ratón (móvil/tablet). */
export function useIsTouch() {
  return useMediaQuery("(hover: none) and (pointer: coarse)");
}
